// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37lI4","toggleWrap":"styles_toggleWrap__3AeQA","content":"styles_content__2Yw1E","selectAreaCode":"styles_selectAreaCode__3tW4V"};